import { render } from "./TermosDeUso.vue?vue&type=template&id=1a34de06&scoped=true"
const script = {}

import "./TermosDeUso.vue?vue&type=style&index=0&id=1a34de06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a34de06"]])

export default __exports__